var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "split",
      staticClass: "az-split",
      class: { "az-split--outline": _vm.outline }
    },
    [
      _c(
        "button",
        {
          staticClass: "az-split__btn az-split__main",
          attrs: { type: "button", disabled: _vm.disabled || _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("click")
            }
          }
        },
        [
          _vm.loading
            ? _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "16",
                  width: "2",
                  color: _vm.outline ? "primary" : "white"
                }
              })
            : _vm.leading
            ? _c("icon-svg", {
                attrs: {
                  name: _vm.leading,
                  size: 15,
                  color: _vm.outline ? "var(--primary)" : "white"
                }
              })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.label) + " ")
        ],
        1
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            left: "",
            "close-on-content-click": false,
            "nudge-bottom": 6,
            "min-width": _vm.menuWidth,
            "content-class": "az-split-menu"
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "az-split__btn az-split__toggle",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled || _vm.loading
                          }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("icon-svg", {
                        staticClass: "az-split__chevron",
                        class: { "az-split__chevron--open": _vm.menuOpen },
                        attrs: {
                          name: "mdi-chevron-down",
                          size: 16,
                          color: _vm.outline ? "var(--primary)" : "white"
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _c(
            "div",
            { staticClass: "az-split__list" },
            [
              _vm._l(_vm.itemsDecorados, function(ref, i) {
                var item = ref.item
                var classe = ref.classe
                var cor = ref.cor
                return [
                  item.tooltip
                    ? _c(
                        "v-tooltip",
                        {
                          key: "tip-" + i,
                          attrs: { left: "", "max-width": "320" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "button",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "az-split__item",
                                            class: classe,
                                            attrs: {
                                              type: "button",
                                              disabled: item.loading,
                                              "aria-describedby": _vm.tipIds[i]
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onItem(item)
                                              }
                                            }
                                          },
                                          "button",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        item.loading
                                          ? _c("v-progress-circular", {
                                              attrs: {
                                                indeterminate: "",
                                                size: "15",
                                                width: "2",
                                                color: cor
                                              }
                                            })
                                          : item.icon
                                          ? _c("icon-svg", {
                                              attrs: {
                                                name: item.icon,
                                                size: 15,
                                                color: cor
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" " + _vm._s(item.label) + " ")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "sr-only",
                                        attrs: { id: _vm.tipIds[i] }
                                      },
                                      [_vm._v(" " + _vm._s(item.tooltip) + " ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("span", [_vm._v(_vm._s(item.tooltip))])]
                      )
                    : _c(
                        "button",
                        {
                          key: i,
                          staticClass: "az-split__item",
                          class: classe,
                          attrs: { type: "button", disabled: item.loading },
                          on: {
                            click: function($event) {
                              return _vm.onItem(item)
                            }
                          }
                        },
                        [
                          item.loading
                            ? _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "15",
                                  width: "2",
                                  color: cor
                                }
                              })
                            : item.icon
                            ? _c("icon-svg", {
                                attrs: { name: item.icon, size: 15, color: cor }
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(item.label) + " ")
                        ],
                        1
                      )
                ]
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }